import React, { type ReactElement } from 'react'
import { useSnapshot } from 'valtio'
import dateFnsFormat from 'date-fns/format'
import { startOfTomorrow } from 'date-fns'
import { recurringPaymentProxy } from '../../../../../../../../shared/proxies/recurringPaymentProxy'
import { handleRadioChange } from '../../utils/utils'
import { StandardDateInput } from '../../../../../../../../shared/components/ui/forms/StandardDateInput'
import { FORMATTED_PAYMENT_RESOLVE_VALUES, PaymentResolveRadioValues } from '../../utils/PaymentResolveRadioValues'

export function PaymentResolveRadioSection (): ReactElement {
  const { resolveRadioValue, nextPaymentDate, recurringPayment } = useSnapshot(recurringPaymentProxy)

  const formattedTomorrow = dateFnsFormat(startOfTomorrow(), 'yyyy-MM-dd')
  const maxDate = recurringPayment?.endDate ?? undefined

  return (
    <div>
      <div className="mt-2 mb-12">
        <div className="flex flex-column items-center my-2">
          <input
            type="radio"
            id={PaymentResolveRadioValues.RESUME_PAYMENT}
            name="payment-option"
            value={PaymentResolveRadioValues.RESUME_PAYMENT}
            checked={resolveRadioValue === PaymentResolveRadioValues.RESUME_PAYMENT}
            onChange={() => { handleRadioChange(PaymentResolveRadioValues.RESUME_PAYMENT) }}
            className="mr-2"
          />
          <label htmlFor={PaymentResolveRadioValues.RESUME_PAYMENT}>{FORMATTED_PAYMENT_RESOLVE_VALUES[PaymentResolveRadioValues.RESUME_PAYMENT]}</label>
        </div>

        {resolveRadioValue === PaymentResolveRadioValues.RESUME_PAYMENT &&
          <StandardDateInput
            additionalOuterClasses="px-4"
            minDate={formattedTomorrow}
            maxDate={maxDate}
            label="Next Occurrence Date"
            value={nextPaymentDate ? nextPaymentDate.toLocaleString() : ''}
            onChange={(e) => {
              recurringPaymentProxy.nextPaymentDate = e.target.value
            }}
            onBlur={(e) => {
              recurringPaymentProxy.nextPaymentDate = e.target.value
            }}
          />}

        <div className="flex items-center">
          <input
            type="radio"
            id={PaymentResolveRadioValues.DONT_RESUME_PAYMENT}
            name="payment-option"
            value={PaymentResolveRadioValues.DONT_RESUME_PAYMENT}
            checked={resolveRadioValue === PaymentResolveRadioValues.DONT_RESUME_PAYMENT}
            onChange={() => { handleRadioChange(PaymentResolveRadioValues.DONT_RESUME_PAYMENT) }}
            className="mr-2"
          />
          <label htmlFor={PaymentResolveRadioValues.DONT_RESUME_PAYMENT}>{FORMATTED_PAYMENT_RESOLVE_VALUES[PaymentResolveRadioValues.DONT_RESUME_PAYMENT]}</label>
        </div>
      </div>

    </div>
  )
}
